export const MY_DATE_FORMATS = {
  parse: {
    dateInput: ['YYYY-MM-DD HH:MM:SS']
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
